let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ayDwU")).then(() => parcelRequire('bg7Pg'));